import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.3",
  "description": "Turborepo 2.3 introduces the Boundaries RFC, along with several ergonomics improvements.",
  "date": "2024/11/14",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.3 introduces several ergonomics improvements:"
  }, {
    "heading": "",
    "content": "Boundaries RFC: Enforce constraints to maintain developer experience"
  }, {
    "heading": "",
    "content": "Package task shortcuts: Execute tasks with turbo run package#task"
  }, {
    "heading": "",
    "content": "Simplified cache control: Easier management of cache sources using a single flag"
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "boundaries-rfc",
    "content": "Monorepos unlock greater iteration speed and incredible flexibility, but also introduce new challenges:"
  }, {
    "heading": "boundaries-rfc",
    "content": "How do we make sure the public API of a package is respected?"
  }, {
    "heading": "boundaries-rfc",
    "content": "How do we communicate where code can and cannot be used to all of our developers?"
  }, {
    "heading": "boundaries-rfc",
    "content": "How can we ensure packages are only used in the right context?"
  }, {
    "heading": "boundaries-rfc",
    "content": "These are only a few examples of a key question when building in monorepos: How do we communicate and enforce the structural integrity of the Workspace?"
  }, {
    "heading": "boundaries-rfc",
    "content": "At the time of publishing this post, the Boundaries RFC is only an initial\ndraft. The implementation described below is subject to change. Please see the\nRFC itself for the most up to date information."
  }, {
    "heading": "boundaries-rfc",
    "content": "The Boundaries RFC is our initial proposal for this problem. In our current approach, we want you to be able to incrementally adopt Boundaries in one line of code:"
  }, {
    "heading": "boundaries-rfc",
    "content": "Additionally, we want to create a tagging system so you can mark domains, concerns, contexts, and other useful metadata with custom Boundaries."
  }, {
    "heading": "boundaries-rfc",
    "content": "We also plan for you to be able to allowlist existing diagnostics with a flag:"
  }, {
    "heading": "boundaries-rfc",
    "content": "This way, you can enforce Boundaries for new code and gradually fix existing issues."
  }, {
    "heading": "boundaries-rfc",
    "content": "We're looking forward to hearing your ideas and feedback on the Boundaries RFC."
  }, {
    "heading": "package-task-shortcuts",
    "content": "You can now run tasks using the fully qualified task identifier:"
  }, {
    "heading": "package-task-shortcuts",
    "content": "This is more convenient than the equivalent command using --filter (turbo run build --filter=web) and allows for more precision if you have multiple tasks that you'd like to target:"
  }, {
    "heading": "package-task-shortcuts",
    "content": "Learn more in the documentation."
  }, {
    "heading": "simplified-cache-control",
    "content": "Previously, the --remote-only and --no-cache flags were used to manage the sources and caching for your output artifacts. However, we've seen how they can cause confusion, and there are gaps in control as far as reading and writing to local and Remote Caches."
  }, {
    "heading": "simplified-cache-control",
    "content": "To refine this, we've introduced a new --cache flag that brings these flags together - and provides more power."
  }, {
    "heading": "simplified-cache-control",
    "content": "Using local and remote, you can control the reading and writing behavior of the turbo invocation. Learn more in the documentation."
  }, {
    "heading": "continued-improvements-for-turbo-query",
    "content": "In 2.2, we introduced turbo query, a feature built for examining your repository using Turborepo's knowledge of your package and task graphs. We've iterated further on this feature to provide you with even more powerful queries:"
  }, {
    "heading": "continued-improvements-for-turbo-query",
    "content": "Implemented reverse file tracing to find which files depend on a specific file"
  }, {
    "heading": "continued-improvements-for-turbo-query",
    "content": "Filters for file tracing to find type-only dependencies"
  }, {
    "heading": "continued-improvements-for-turbo-query",
    "content": "Package names that you provide are now validated to ensure that they exist"
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 2.2, we've seen great adoption and community growth:"
  }, {
    "heading": "community",
    "content": "26.3+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "3.4M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "496 years of compute time saved using Vercel Remote Cache"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team: Anthony, Chris, Nicholas, and Tom."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "boundaries-rfc",
    "content": "Boundaries RFC"
  }, {
    "id": "package-task-shortcuts",
    "content": "Package task shortcuts"
  }, {
    "id": "simplified-cache-control",
    "content": "Simplified cache control"
  }, {
    "id": "continued-improvements-for-turbo-query",
    "content": "Continued improvements for turbo query"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Tab, Tabs} from '#components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#boundaries-rfc",
  title: _jsx(_Fragment, {
    children: "Boundaries RFC"
  })
}, {
  depth: 2,
  url: "#package-task-shortcuts",
  title: _jsx(_Fragment, {
    children: "Package task shortcuts"
  })
}, {
  depth: 2,
  url: "#simplified-cache-control",
  title: _jsx(_Fragment, {
    children: "Simplified cache control"
  })
}, {
  depth: 2,
  url: "#continued-improvements-for-turbo-query",
  title: _jsxs(_Fragment, {
    children: ["Continued improvements for ", _jsx("code", {
      children: "turbo query"
    })]
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.3"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, November 14th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['chrisolszewski', 'nicholasyang', 'anthonyshew']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.3 introduces several ergonomics improvements:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#boundaries-rfc",
          children: _jsx(_components.strong, {
            children: "Boundaries RFC"
          })
        }), ": Enforce constraints to maintain developer experience"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#package-task-shortcuts",
          children: _jsx(_components.strong, {
            children: "Package task shortcuts"
          })
        }), ": Execute tasks with ", _jsx(_components.code, {
          children: "turbo run package#task"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#simplified-cache-control",
          children: _jsx(_components.strong, {
            children: "Simplified cache control"
          })
        }), ": Easier management of cache sources using a single flag"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "boundaries-rfc",
      children: "Boundaries RFC"
    }), "\n", _jsx(_components.p, {
      children: "Monorepos unlock greater iteration speed and incredible flexibility, but also introduce new challenges:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "How do we make sure the public API of a package is respected?"
      }), "\n", _jsx(_components.li, {
        children: "How do we communicate where code can and cannot be used to all of our developers?"
      }), "\n", _jsx(_components.li, {
        children: "How can we ensure packages are only used in the right context?"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "These are only a few examples of a key question when building in monorepos: How do we communicate and enforce the structural integrity of the Workspace?"
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "At the time of publishing this post, the Boundaries RFC is only an initial\ndraft. The implementation described below is subject to change. Please see the\nRFC itself for the most up to date information."
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9435",
        children: "The Boundaries RFC"
      }), " is our initial proposal for this problem. In our current approach, we want you to be able to incrementally adopt Boundaries in one line of code:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Additionally, we want to create a tagging system so you can mark domains, concerns, contexts, and other useful metadata with custom Boundaries."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/ui/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"tags\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"library\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"frontend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"beta\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"allowDependencyOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"library\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"frontend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"denyDependencyFrom\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"backend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"stable\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "We also plan for you to be able to allowlist existing diagnostics with a flag:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " boundaries"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --exclude-errors"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "This way, you can enforce Boundaries for new code and gradually fix existing issues."
    }), "\n", _jsxs(_components.p, {
      children: ["We're looking forward to hearing your ideas and feedback on ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9435",
        children: "the Boundaries RFC"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "package-task-shortcuts",
      children: "Package task shortcuts"
    }), "\n", _jsx(_components.p, {
      children: "You can now run tasks using the fully qualified task identifier:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#build"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This is more convenient than the equivalent command using ", _jsx(_components.code, {
        children: "--filter"
      }), " (", _jsx(_components.code, {
        children: "turbo run build --filter=web"
      }), ") and allows for more precision if you have multiple tasks that you'd like to target:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " docs#lint"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#filtering-by-package",
        children: "Learn more in the documentation."
      })
    }), "\n", _jsx(_components.h2, {
      id: "simplified-cache-control",
      children: "Simplified cache control"
    }), "\n", _jsxs(_components.p, {
      children: ["Previously, the ", _jsx(_components.code, {
        children: "--remote-only"
      }), " and ", _jsx(_components.code, {
        children: "--no-cache"
      }), " flags were used to manage the sources and caching for your output artifacts. However, we've seen how they can cause confusion, and there are gaps in control as far as reading and writing to local and Remote Caches."]
    }), "\n", _jsxs(_components.p, {
      children: ["To refine this, we've introduced a new ", _jsx(_components.code, {
        children: "--cache"
      }), " flag that brings these flags together - and provides more power."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw,remote:r"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Using ", _jsx(_components.code, {
        children: "local"
      }), " and ", _jsx(_components.code, {
        children: "remote"
      }), ", you can control the reading and writing behavior of the ", _jsx(_components.code, {
        children: "turbo"
      }), " invocation. Learn more in the ", _jsx(_components.a, {
        href: "/docs/reference/run#--cache-options",
        children: "documentation"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "continued-improvements-for-turbo-query",
      children: ["Continued improvements for ", _jsx(_components.code, {
        children: "turbo query"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In 2.2, we introduced ", _jsx(_components.code, {
        children: "turbo query"
      }), ", a feature built for examining your repository using Turborepo's knowledge of your package and task graphs. We've iterated further on this feature to provide you with even more powerful queries:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Implemented reverse file tracing to find which files depend on a specific file"
      }), "\n", _jsx(_components.li, {
        children: "Filters for file tracing to find type-only dependencies"
      }), "\n", _jsx(_components.li, {
        children: "Package names that you provide are now validated to ensure that they exist"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-2-2-0",
        children: "Turborepo 2.2"
      }), ", we've seen great adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "26.3+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "3.4M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["496 years of compute time saved using ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is the result of the combined work of all of its contributors, including our core team: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", and ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
